// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"f554feab","256":"8019f90c","328":"b654deba","430":"800188f8"}[chunkId] + ".chunk.js";
};